var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "29 39 42 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.2928932,60.7071068 C69.6834175,61.0976311 70.3165825,61.0976311 70.7071068,60.7071068 C71.0976311,60.3165825 71.0976311,59.6834175 70.7071068,59.2928932 L50.7071068,39.2928932 C50.3165825,38.9023689 49.6834175,38.9023689 49.2928932,39.2928932 L29.2928932,59.2928932 C28.9023689,59.6834175 28.9023689,60.3165825 29.2928932,60.7071068 C29.6834175,61.0976311 30.3165825,61.0976311 30.7071068,60.7071068 L50.0094444,41.4047691 L69.2928932,60.7071068 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevron);
export default __webpack_public_path__ + "static/media/icon-chevron.0456157010a2f21501dc60933f04cd55.svg";
export { ForwardRef as ReactComponent };